import { MenuConfig } from '@tencent/workbench';
import { MenuKey } from '../../schema/menu-schema/common';
import i18n from '@i18next/i18n';


export const config = {
    id: MenuKey.RENAME,
    title: i18n.t('重命名'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.RENAME,
        content: config.title,
    },
];
